import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import SiteFooter from './components/SiteFooter';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from './pages/Dashboard';
import NewReview from './pages/NewReview';
import ReviewView from './pages/ReviewView';
import AnalysisProgress from './pages/AnalysisProgress';
import ResultsDashboard from './pages/ResultsDashboard';
import Trends from './pages/Trends';
import './styles/global.css';

// Share build: REACT_APP_SHARE_ID is baked in at build time (see backend/share_app.py).
// Every other page (Dashboard, New Analysis, Trends, other reviews) is left out of
// the bundle's routes entirely — there is nothing to navigate to except this one
// review's results. The backend enforces the same restriction independently.
const SHARE_ID = process.env.REACT_APP_SHARE_ID;

function ShareBrand() {
  return (
    <nav className="site-nav" style={{
      background: 'var(--cream)',
      display: 'flex', alignItems: 'center',
      height: 72, padding: '0 32px',
      position: 'sticky', top: 0, zIndex: 100,
      boxShadow: '0 1px 20px rgba(60,50,20,0.10)',
    }}>
      <span translate="no" style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1 }}>
        <span style={{ fontSize: 20, fontWeight: 700, color: 'var(--ink)', letterSpacing: '-0.02em' }}>
          DossierProof
        </span>
        <span style={{ fontSize: 9.5, fontWeight: 500, color: 'var(--text-label)', letterSpacing: '0.32em', marginTop: 3 }}>
          BY HENDRIKS HOUSING
        </span>
      </span>
    </nav>
  );
}

export default function App() {
  if (SHARE_ID) {
    return (
      <BrowserRouter>
        <ShareBrand />
        <ErrorBoundary>
          <Routes>
            <Route path="*" element={<ResultsDashboard />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <NavBar />
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/new" element={<NewReview />} />
          <Route path="/reviews/:id" element={<ReviewView />} />
          <Route path="/reviews/:id/progress/:runId" element={<AnalysisProgress />} />
          <Route path="/reviews/:id/results" element={<ResultsDashboard />} />
          <Route path="/trends" element={<Trends />} />
        </Routes>
      </ErrorBoundary>
      <SiteFooter />
    </BrowserRouter>
  );
}
